import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DEFAULT_CSS } from '../../constants/commonConstants';
import { TenantAPIService } from '../../services/api/tenant-api.service';

@Component({
  selector: 'app-language-popup',
  templateUrl: './css-file-popup.component.html',
  styleUrls: ['./css-file-popup.component.scss'],
  standalone: false,
})
export class CssFilePopupComponent {
  public constructor(
    private _activeModal: NgbActiveModal,
    private _fileAPIService: TenantAPIService
  ) {}

  public closeHandler() {
    this._activeModal.close();
  }

  public downloadHandler() {
    this._fileAPIService.GetTenantTheme().subscribe(file => {
      const data = file.isDefault ? DEFAULT_CSS : file.data;
      const blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
      const objectUrl = URL.createObjectURL(blob);
      const element = document.createElement('a');
      element.href = objectUrl;
      element.download = 'file.css';
      element.click();
      URL.revokeObjectURL(objectUrl);
    });
  }

  public uploadHandler(event: any) {
    const file = event?.target?.files[0];
    let data = null;
    const reader = new FileReader();
    reader.onload = () => {
      data = reader.result;
      this._fileAPIService.SaveTenantTheme(data).subscribe(x => {
        window.location.reload();
      });
    };
    reader.readAsText(file);
  }
}
